import { t, useLocale } from '../lib/i18n.js';
import type { PlayerPublic } from '@listen-draw/shared';

export function Podium({ players }: { players: PlayerPublic[] }) {
  useLocale();
  const [first, second, third] = players;
  const slot = (p: PlayerPublic | undefined, rank: 1 | 2 | 3) => (
    <div className={`podium__slot podium__slot--${rank}`}>
      <div className="podium__rank">{rank === 1 ? '1ST' : rank === 2 ? '2ND' : '3RD'}</div>
      <div className="podium__name">{p?.name ?? '—'}</div>
      <div className="podium__score num">{p ? p.score : ''}</div>
      {p && (
        <div className="muted small">
          {t('Correct: ', '正解 ')}
          {p.correct}
        </div>
      )}
    </div>
  );
  return (
    <div className="podium">
      {slot(second, 2)}
      {slot(first, 1)}
      {slot(third, 3)}
    </div>
  );
}
